import { gql } from '@apollo/client';
import React from 'react';

interface Props {
  changes?: {
    type: {
      additions: number;
      removals: number;
      edits: number;
    };
    field: {
      additions: number;
      removals: number;
      edits: number;
    };
  };
}

// TODO (launches): This relies on us having access to this info on the backend
export const LaunchSchemaChangeSummaryFragment = gql`
  fragment LaunchSchemaChangeSummaryFragment on ChangeSummary {
    type {
      additions
      removals
      edits
    }
    field {
      additions
      removals
      edits
    }
  }
`;

export const SchemaChangeSummaryTable = ({ changes }: Props) => (
  <>
    <div className="truncate">
      <span className="mr-4 text-xs text-placeholder">types</span>
      <span
        className="mr-2 inline-block w-4 text-left font-mono text-xs text-success"
        title="# of types added"
      >
        +{changes?.type.additions ?? 0}
      </span>
      <span
        className="mr-2 inline-block w-4 text-left font-mono text-xs text-error"
        title="# of types removed"
      >
        -{changes?.type.removals ?? 0}
      </span>
      <span
        className="inline-block w-4 text-left font-mono text-xs text-secondary"
        title="# of types changed"
      >
        {changes?.type.edits ?? 0}
      </span>
    </div>
    <div className="truncate">
      <span className="mr-4 text-xs text-placeholder">fields</span>
      <span
        className="mr-2 inline-block w-4 text-left font-mono text-xs text-success"
        title="# of fields added"
      >
        +{changes?.field.additions ?? 0}
      </span>
      <span
        className="mr-2 inline-block w-4 text-left font-mono text-xs text-error"
        title="# of fields removed"
      >
        -{changes?.field.removals ?? 0}
      </span>
      <span
        className="inline-block w-4 text-left font-mono text-xs text-secondary"
        title="# of fields changed"
      >
        {changes?.field.edits ?? 0}
      </span>
    </div>
  </>
);
